// extracted by mini-css-extract-plugin
module.exports = {"t1dya0gx":"t1dya0gx","t2e4fmj":"t2e4fmj","tidlq8k":"tidlq8k","toggleTextGradient-tidlq8k":"toggleTextGradient-tidlq8k"};